export default __webpack_public_path__ + "static/Scroll-Image---Barn-Demolition-5b5f742e94579def2b5aad5c8c9c8023.jpg";